var _path, _g, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1235_12547",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 35
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.983887 0H35.9679V35H0.983887V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1235_12547)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.9679 29.6811C35.9679 32.6146 33.5829 35 30.6508 35H6.30038C3.36819 35 0.983887 32.6146 0.983887 29.6811V5.31892C0.983887 2.38602 3.36819 0 6.30038 0H30.6508C33.5829 0 35.9679 2.38602 35.9679 5.31892V29.6811Z",
    fill: "#E52D27"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8757 17.7773C30.8757 19.7125 30.8757 21.7633 30.4439 23.6381C30.14 24.9584 29.063 25.9261 27.7613 26.0721C24.6894 26.413 21.575 26.4192 18.4787 26.413C15.3762 26.413 12.2736 26.413 9.19544 26.0721C7.90002 25.9261 6.81738 24.9584 6.51286 23.6381C6.08105 21.7633 6.08105 19.7125 6.08105 17.7773C6.08105 15.842 6.08729 13.7906 6.51286 11.9164C6.81738 10.5955 7.89378 9.62782 9.19544 9.48173C12.2736 9.13525 15.3818 9.13525 18.4787 9.13525C21.575 9.13525 24.6832 9.13525 27.7613 9.48173C29.0568 9.62782 30.14 10.5955 30.4439 11.9164C30.8757 13.7906 30.8757 15.842 30.8757 17.7773Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8687 13.1641V22.4328L23.0653 17.7956L15.8687 13.1641Z",
    fill: "#E52D27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.2e0fd785f178b3295a3fe33c1aee7f52.svg";
export { ForwardRef as ReactComponent };